<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <CalendarArrowRight /> -->
  </div>
</template>

<script>
// import CalendarArrowRight from "vue-material-design-icons/CalendarArrowRight.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiCalendarArrowRight } from "@mdi/js"

export default {
  name: "CalendarArrowRightIcon",
  components: {
    SvgIcon
    // CalendarArrowRight,
  },
  data() {
    return {
      path: mdiCalendarArrowRight,
    }
  }
}
</script>
